import RepositoryWorker from "../RepositoryWorker";

export interface DeviceCommandDto {
    type: string;
    name: string;
    identity: string;
}

export enum CommandExecutionStatus {
    OK = 'ok',
    ERROR = 'error',
}

export interface CommandExecutionResponse {
    status: CommandExecutionStatus;
}

export class DeviceCommandsRepository {
    static getAllByDevice(deviceId: number): Promise<{commands: DeviceCommandDto[]}> {
        return RepositoryWorker
            .makeGetCallInternal(`/api/v1/devices/${deviceId}/commands`);
    }

    static executeCommand(deviceId: number, commandIdentity: string): Promise<CommandExecutionResponse> {
        return RepositoryWorker
            .makePostCallInternal(
                `/api/v1/devices/${deviceId}/commands/${commandIdentity}`,
                {
                    identity: commandIdentity,
                    payload: [],
                }
            );
    }
}